import React from 'react';

import ChapterSettingsContainer from 'containers/ChapterSettingsContainer';
import { ROUTE_ALBUMS } from 'utils/constants/routes';
import chapterIdFromMatch from 'utils/history/chapter-id-from-match';

export default (props: any) => {
  const chapterId = chapterIdFromMatch(props.match);
  if (!chapterId) {
    return null;
  }

  const baseRoute = ROUTE_ALBUMS + '/' + chapterId;

  return (
    <ChapterSettingsContainer
      history={props.history}
      active={props.location?.query?.active}
      chapterId={chapterId}
      baseRoute={baseRoute + '/settings'}
      backRoute={baseRoute}
    />
  );
};
